import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {SettingsService} from '../settings/settings.service';
import {AppConstants} from './app.constants';
import {ShiftService} from '../shifts/shift.service';
import {UserService} from './user.service';
import {FreelancerService} from '../freelancers/freelancer.service';
import {ProfileService} from '../profile/profile.service';
import {DashboardService} from '../dashboard/dashboard.service';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [],
  providers: [
    AppConstants,
    ShiftService,
    SettingsService,
    UserService,
    FreelancerService,
    ProfileService,
    DashboardService
  ]
})
export class CoreModule {
}



// WEBPACK FOOTER //
// /Users/bitcot/Projects/PouredHQ/getpoured-popup-angular/src/app/shared/core.module.ts